import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";

export interface WelcomeModalProps {
  open: boolean;
  onStart: () => void;
  onSkip: () => void;
  translate?: (key: string, fallback?: string) => string;
  totalSteps?: number;
}

// Initial-login welcome modal that offers to launch the guided tour.
// A-9 spec: MUI Dialog default z-index 1300 is above the react-toastify
// container (~1000) and the tour widget (z-index 1050), so no manual
// adjustment is needed here.
export function WelcomeModal(props: WelcomeModalProps) {
  const { open, onStart, onSkip, translate, totalSteps = 8 } = props;
  const t = (key: string, fallback: string) =>
    translate ? translate(key, fallback) : fallback;

  return (
    <Dialog
      open={open}
      onClose={onSkip}
      aria-labelledby="tutorial-welcome-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="tutorial-welcome-title">
        {t("tutorial.welcome.title", "TasTeck 初回セットアップ")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          {t(
            "tutorial.welcome.body",
            "TasTeck へようこそ。 これから店舗登録から初回受注メール送信まで、実際の画面操作でご案内します。"
          )}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t("tutorial.welcome.stepCount", `全 ${totalSteps} ステップ・所要 5-10 分`).replace(
            "${totalSteps}",
            String(totalSteps)
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSkip} color="default">
          {t("tutorial.welcome.skip", "後で")}
        </Button>
        <Button
          onClick={onStart}
          color="primary"
          variant="contained"
          data-tutorial="welcome-start"
        >
          {t("tutorial.welcome.start", "案内を開始")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
